import { type Registry as Services, service } from '@ember/service';
import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { getDemoInfo } from 'frontend-utils/utils/hash';
import type CentralMappingMarketSubscriptionChain from 'lumen/models/central-mapping/market-subscription-chain';

export default class CentralMappingMarketSubscription extends Model {
  [Type] = 'central-mapping/market-subscription' as const;

  @hasMany('central-mapping/market-subscription-chain', {
    async: false,
    inverse: null,
  })
  declare brandsDetails: CentralMappingMarketSubscriptionChain[];

  @hasMany('central-mapping/market-subscription-chain', {
    async: false,
    inverse: null,
  })
  declare chainsDetails: CentralMappingMarketSubscriptionChain[];

  @attr() declare brands: string[];
  @attr() declare chains: string[];
  @attr('string') declare marketId: string;
  /** The name of the market subscription. Use displayName instead for demo mode support. */
  @attr('string') declare name: string;

  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  /** Returns the display name for the market subscription, adjusting for demo mode if active. */
  get displayName(): string {
    if (this.hotelAndMarketService.isDemoModeActive) {
      const demoInfo = getDemoInfo(this.name);

      if (!demoInfo) {
        return 'Hotel';
      }

      return `Hotel ${demoInfo.id}`;
    }

    return this.name;
  }
}
